"use client";

import { SDUIComponentInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUICarousel } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Carousel/__internal__/SDUICarousel";
import { SDUICarouselHeaderRow } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Carousel/__internal__/SDUICarouselHeaderRow";
import { SDUICarouselRendererWrapper } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Carousel/SDUICarouselRendererWrapper";
import { CarouselVariant } from "@faire/web-api--source/indigofair/data/CarouselVariant";
import React from "react";

export const SDUICarouselRenderer: React.FC<
  SDUIComponentInstanceRendererProps
> = ({ component, loggingData, renderBehaviour }) => {
  const carouselElement = component.carousel_component;
  if (!carouselElement) {
    return null;
  }

  const { title, cta_button, sub_title, tiles, tagline, style, variant } =
    carouselElement;
  if (tiles === undefined || tiles.length === 0) {
    return null;
  }

  const numberOfRows =
    variant === CarouselVariant.CAROUSEL_VARIANT_TWO_ROW ||
    variant === CarouselVariant.CAROUSEL_VARIANT_DYNAMIC_TWO_ROW
      ? 2
      : 1;

  return (
    <SDUICarouselRendererWrapper>
      <SDUICarouselHeaderRow
        title={title}
        cta_button={cta_button}
        sub_title={sub_title}
        tagline={tagline}
        loggingData={loggingData}
      />
      <SDUICarousel
        style={style}
        tiles={tiles}
        loggingData={loggingData}
        renderBehaviour={renderBehaviour}
        numberOfRows={numberOfRows}
        hasDynamicRows={
          variant === CarouselVariant.CAROUSEL_VARIANT_DYNAMIC_TWO_ROW
        }
      />
    </SDUICarouselRendererWrapper>
  );
};
